<template>
	<div class="container">
		<el-card>
			<div slot="header">商户信息管理</div>
			<div style="height: 100%">
				<el-button icon="el-icon-edit" style="background-color: #23c6c8 !important" @click="editMerchant">
					编辑</el-button>
				<el-button type="primary" icon="el-icon-edit" @click="editAppletContact">更改小程序联系人</el-button>
				<el-button type="primary" icon="el-icon-edit" @click="addBlacklist">添加黑名单</el-button>
				<el-form ref="form" :model="form" label-width="80px" size="small" class="searchForm"
					style="margin-top: 15px">
					<el-form-item label="商户编号" label-width="70px">
						<el-input v-model="queryParams.code" class="searchTag" clearable></el-input>
					</el-form-item>
					<el-form-item label="商户名称">
						<el-select v-model="queryParams.name" placeholder="" clearable class="searchTag" filterable>
							<el-option v-for="item in lesseeNameOptions" :key="item.name" :label="item.name"
								:value="item.name">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="小程序联系人电话" label-width="140px">
						<el-input v-model="queryParams.systemAdminPhone" class="searchTag" clearable></el-input>
					</el-form-item>
					<el-form-item label="电表账户小于" label-width="110px">
						<el-input v-model="queryParams.meterAccount" class="searchTag" clearable></el-input>
					</el-form-item>
					<el-form-item label="水表账户小于" label-width="110px">
						<el-input v-model="queryParams.waterAccount" class="searchTag" clearable></el-input>
					</el-form-item>
					<el-button type="primary" size="small" icon="el-icon-search" style="margin-left: 10px"
						@click="handleQuery">搜索</el-button>
				</el-form>
				<div class="tableStyle">
					<el-table :data="tableData" style="width: 100%" height="92%" ref="merchantInfoTable"
						highlight-current-row @current-change="handleCurrentChange">
						<el-table-column type="index" width="50" label="序号" align="center" :index="indexMethod">
						</el-table-column>
						<el-table-column prop="editorTime" label="创建时间" width="160" align="center">
						</el-table-column>
						<el-table-column prop="editorName" label="创建人" align="center">
						</el-table-column>
						<el-table-column prop="code" label="商户编号" width="100" align="center">
						</el-table-column>
						<el-table-column prop="name" label="商户名称" width="150" align="center">
						</el-table-column>
						<el-table-column prop="contactMan" label="商户联系人" width="100" align="center">
						</el-table-column>
						<el-table-column prop="phone" label="联系人电话" width="150" align="center">
						</el-table-column>
						<el-table-column prop="systemAdmin" label="小程序联系人" width="110" align="center">
						</el-table-column>
						<el-table-column prop="systemAdminPhone" label="小程序联系人电话" width="150" align="center">
						</el-table-column>
						<el-table-column prop="detailAddress" label="联系地址" width="150" align="center">
						</el-table-column>
						<el-table-column prop="electricBalance" label="电账户余额（元）" width="140" align="center">
						</el-table-column>
						<el-table-column prop="waterBalance" label="水账户余额（元）" width="140" align="center">
						</el-table-column>
						<el-table-column prop="modifyTime" label="修改时间" width="160" align="center">
						</el-table-column>
					</el-table>
					<div class="block">
						<el-pagination v-show="total > 0" @size-change="handleQuery" @current-change="handleQuery"
							:current-page.sync="queryParams.current" :page-sizes="[100, 200, 400, 600, 800, 1000]"
							:page-size.sync="queryParams.size" layout="total, sizes, prev, pager, next, jumper"
							:total="total">
						</el-pagination>
					</div>
				</div>
			</div>
		</el-card>
		<!-- 修改商户信息 -->
		<el-dialog title="修改商户信息" :visible.sync="editDialogVisible" width="800px">
			<el-form ref="editForm" :model="editForm" label-width="110px" :rules="editFormRules" size="small">
				<el-row :gutter="10">
					<el-col :md="12">
						<el-form-item label="商户编号" prop="code">
							<el-input v-model="editForm.code" placeholder="" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :md="12">
						<el-form-item label="商户名称" prop="name">
							<el-input v-model="editForm.name"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :md="12">
						<el-form-item label="商户联系人" prop="contactMan">
							<el-input v-model="editForm.contactMan"></el-input>
						</el-form-item>
					</el-col>
					<el-col :md="12">
						<el-form-item label="电话" prop="phone">
							<el-input v-model="editForm.phone"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :md="12">
						<el-form-item label="区域" prop="districtId">
							<el-cascader v-model="editForm.districtId" :options="districtIdOptions" :props="props"
								clearable></el-cascader>
						</el-form-item>
					</el-col>
					<el-col :md="12">
						<el-form-item label="地址" prop="address">
							<el-input v-model="editForm.address"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :md="12">
						<el-form-item label="小程序联系人" prop="systemAdmin">
							<el-input v-model="editForm.systemAdmin"></el-input>
						</el-form-item>
					</el-col>
					<el-col :md="12">
						<el-form-item label="电话" prop="systemAdminPhone">
							<el-input v-model="editForm.systemAdminPhone"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :md="12">
						<el-form-item label="业态" prop="type">
							<el-select v-model="editForm.type" placeholder="请选择" style="width: 100%">
								<el-option v-for="item in lesseeTypeOptions" :key="item.key" :label="item.value"
									:value="item.key"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="备注" prop="remark">
							<el-input v-model="editForm.remark"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="saveEdit">保 存</el-button>
				<el-button @click="editDialogVisible = false">取 消</el-button>
			</span>
		</el-dialog>
		<!-- 更改小程序联系人 -->
		<el-dialog title="更改小程序联系人" :visible.sync="appletContactDialogVisible" width="800px" class="changeAppletClass">
			<div>
				<div>
					<el-form :model="editAppletForm" label-width="120px" size="small">
						<el-row :gutter="10">
							<el-col :span="12">
								<el-form-item label="商户编号">
									<el-input v-model="editAppletForm.code" disabled></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="商户名称">
									<el-input v-model="editAppletForm.name" disabled></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="10">
							<el-col :span="12">
								<el-form-item label="原小程序联系人">
									<el-input v-model="editAppletForm.systemAdmin" disabled></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="原小程序电话">
									<el-input v-model="editAppletForm.systemAdminPhone" disabled></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="10">
							<el-col :span="12">
								<el-form-item label="小程序联系人">
									<el-input v-model="editAppletForm.systemAdminNew"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="小程序电话">
									<el-input v-model="editAppletForm.systemAdminPhoneNew"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="10">
							<el-col :span="24">
								<el-form-item label-width="0" class="saveStyle">
									<el-button type="primary" @click="saveApplet">保存</el-button>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</div>
				<div>
					<el-form :model="slectListByLesseeIdForm" label-width="80px" size="small" inline>
						<el-row :gutter="10">
							<el-col :span="10">
								<el-form-item label="开始时间">
									<el-date-picker v-model="slectListByLesseeIdForm.createStartTime" type="datetime"
										placeholder="选择日期时间" size="small" value-format="yyyy-MM-dd HH:mm:ss"
										:clearable="false">
									</el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="10">
								<el-form-item label="结束时间">
									<el-date-picker v-model="slectListByLesseeIdForm.createEndTime" type="datetime"
										placeholder="选择日期时间" size="small" value-format="yyyy-MM-dd HH:mm:ss"
										:clearable="false">
									</el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="4">
								<el-button type="primary" size="small" icon="el-icon-search" @click="handleQueryList">搜索
								</el-button>
							</el-col>
						</el-row>
					</el-form>
					<div style="height: 200px">
						<el-table :data="tableDataList" style="width: 100%" height="100%">
							<el-table-column prop="lesseeCode" label="商户编号" align="center">
							</el-table-column>
							<el-table-column prop="lesseeName" label="商户名称" align="center">
							</el-table-column>
							<el-table-column prop="lesseeAdminOld" label="原小程序联系人" align="center">
							</el-table-column>
							<el-table-column prop="lesseePhoneOld" label="原小程序电话" align="center">
							</el-table-column>
							<el-table-column prop="lesseeAdmin" label="小程序联系人" align="center">
							</el-table-column>
							<el-table-column prop="lesseePhone" label="小程序电话" align="center">
							</el-table-column>
						</el-table>
						<div class="block">
							<el-pagination v-show="total1 > 0" @size-change="handleQueryList"
								@current-change="handleQueryList" :current-page.sync="slectListByLesseeIdForm.current"
								:page-sizes="[10, 20, 30, 50, 80]" :page-size.sync="slectListByLesseeIdForm.size"
								layout="total, sizes, prev, pager, next, jumper" :total="total1">
							</el-pagination>
						</div>
					</div>
				</div>
			</div>
			<div slot="footer">
				<el-button @click="appletContactDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="appletContactDialogVisible = false">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		selectList,
		detail,
		saveEdit,
		updateMiniProgramContactInfo,
		selectListByLesseeIdPc,
		blackList
	} from '../../api/property/merchantInfo';
	import {
		translateObjectEmptyAttributeToNull
	} from '../../untils/func';
	import {
		selectComboboxTreeData,
		selectDictionaryListByName,
	} from '../../api/comboboxLoad';
	import dictionaryConstant from '../../constant/dictionaryConstant';
	import {
		cascaderAfferentString,
		cascaderAfferentNumber,
		cascaderAfferentArray,
	} from '../../untils/func.js';
	export default {
		data() {
			return {
				lesseeNameQueryParams: {
					current: 1,
					size: 10000,
				},
				lesseeNameOptions: [],
				form: {},
				editForm: {},
				editAppletForm: {},
				slectListByLesseeIdForm: {
					current: 1,
					size: 100,
					lesseeId: '',
				},
				editFormRules: {
					code: [{
						required: true,
						message: '请输入商户编号',
						trigger: 'blur',
					}, ],
					name: [{
						required: true,
						message: '请输入商户名称',
						trigger: 'blur',
					}, ],
					contactMan: [{
						required: true,
						message: '请输入商户联系人',
						trigger: 'blur',
					}, ],
					systemAdmin: [{
						required: true,
						message: '请输入小程序联系人',
						trigger: 'blur',
					}, ],
					phone: [{
							required: true,
							message: '请输入手机号码',
							trigger: 'blur',
						},
						{
							min: 11,
							max: 11,
							message: '请输入11位手机号码',
							trigger: 'blur',
						},
						{
							pattern: /^(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/,
							message: '请输入正确的手机号码',
							trigger: 'blur',
						},
					],
					systemAdminPhone: [{
							required: true,
							message: '请输入手机号码',
							trigger: 'blur',
						},
						{
							min: 11,
							max: 11,
							message: '请输入11位手机号码',
							trigger: 'blur',
						},
						{
							pattern: /^(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/,
							message: '请输入正确的手机号码',
							trigger: 'blur',
						},
					],

					type: [{
						required: true,
						message: '请选择业态',
						trigger: 'change',
					}, ],
					districtId: [{
						required: true,
						message: '请选择区域',
						trigger: 'blur',
					}, ],
					electricBalance: [{
							required: true,
							trigger: 'blur',
							message: '请输入商户电账户当前金额',
						},
						{
							pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
							message: '请输入正确金额格式,可保留两位小数',
						},
					],
					waterBalance: [{
							required: true,
							trigger: 'blur',
							message: '请输入商户水账户当前金额',
						},
						{
							pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
							message: '请输入正确金额格式,可保留两位小数',
						},
					],
				},
				currentRow: null,
				editDialogVisible: false,
				appletContactDialogVisible: false,
				// 查询参数
				queryParams: {
					current: 1,
					size: 100,
					name: '',
					code: '',
				},
				loading: false,
				total: 0,
				total1: 0,
				tableData: [],
				districtIdOptions: [], //区域 options
				lesseeTypeOptions: [], //业态 options
				props: {
					expandTrigger: 'hover',
				},
				tableDataList: [],
			};
		},
		created() {
			this.init();
		},
		mounted() {},
		watch: {},
		methods: {
			async init() {
				await this.handleQuery();

				await this.selectComboboxTreeData();
				await this.getLesseeType();
				await this.getLesseeNameOption();
			},
			async handleQuery() {
				this.loading = true;
				let param = this.queryParams;
				param = translateObjectEmptyAttributeToNull(param);
				const response = await selectList(param).then();
				this.tableData = response.data;
				this.total = response.total;
				this.loading = false;
				this.cancelChoose();
			},
			// 获取商户名称下拉框
			async getLesseeNameOption() {
				let param = this.lesseeNameQueryParams;
				param = translateObjectEmptyAttributeToNull(param);
				const response = await selectList(param).then();
				this.lesseeNameOptions = response.data;
			},
			async handleQueryList() {
				this.loading = true;
				let param = {
					createStartTime: this.slectListByLesseeIdForm.createStartTime,
					createEndTime: this.slectListByLesseeIdForm.createEndTime,
					lesseeId: this.currentRow,
				};
				const response = await selectListByLesseeIdPc(param).then();
				this.tableDataList = response.data;
				this.total1 = response.total;
				this.loading = false;
			},
			// 单选表格某一行
			handleCurrentChange(val) {
				this.currentRow = val.id;
			},
			cancelChoose() {
				this.$refs.merchantInfoTable.setCurrentRow();
				this.currentRow = null;
			},
			// 添加黑名单
			async addBlacklist() {
				if (this.currentRow == null) {
					this.$message.error('请先选择某条数据！');
				} else {
					await blackList({
						lesseeId: this.currentRow
					}).then();
					this.msgSuccess('添加成功');
					await this.handleQuery();
				}
			},
			// 更改小程序联系人 打开对话框
			async editAppletContact() {
				if (this.currentRow == null) {
					this.$message.error('请先选择某条数据！');
				} else {
					const res = await detail(this.currentRow).then();
					this.editAppletForm = res.data;
					this.slectListByLesseeIdForm.lesseeId = this.editAppletForm.id;
					this.appletContactDialogVisible = true;
					this.slectListByLesseeIdForm = {};
					this.tableDataList = [];
					await this.handleQueryList();
				}
			},
			async saveApplet() {
				await updateMiniProgramContactInfo({
					lesseeId: this.editAppletForm.id,
					lesseeAdminOld: this.editAppletForm.systemAdmin,
					lesseePhoneOld: this.editAppletForm.systemAdminPhone,
					lesseeAdmin: this.editAppletForm.systemAdminNew,
					lesseePhone: this.editAppletForm.systemAdminPhoneNew,
				}).then();
				this.msgSuccess('保存成功');
			},
			// 编辑
			async editMerchant() {
				if (this.currentRow == null) {
					this.$message.error('请先选择某条数据！');
				} else {
					const res = await detail(this.currentRow).then();
					this.editForm = res.data;
					this.editForm.districtId = cascaderAfferentArray(
						this.editForm.districtData
					);
					this.editDialogVisible = true;
				}
			},
			async saveEdit() {
				this.$refs.editForm.validate(async (valid) => {
					if (valid) {
						let res = this.editForm;
						res.districtData = cascaderAfferentString(res.districtId);
						res.districtId = cascaderAfferentNumber(res.districtId);
						await saveEdit(res).then();
						await this.handleQuery();
						this.msgSuccess('保存成功');
						this.editDialogVisible = false;
						this.currentRow = null;
					} else {
						this.msgError('信息填写错误');
						return false;
					}
				});
			},
			// 区域下拉框
			async selectComboboxTreeData() {
				const res = await selectComboboxTreeData().then();
				this.districtIdOptions = res.data;
			},
			// 获取业态下拉列表数据
			async getLesseeType() {
				const res = await selectDictionaryListByName(
					dictionaryConstant.LESSEE_TYPE
				).then();
				this.lesseeTypeOptions = res.data;
			},
			indexMethod(index) {
				let num =
					this.queryParams.size * (this.queryParams.current - 1) + index + 1;
				return num;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.container {
		padding: 0 10px;
		height: 100%;
	}

	/deep/ .el-card__header {
		background-color: var(--secondColor) !important;
		color: var(--whiteColor);
	}

	/deep/ .el-form-item {
		display: inline-block;
	}

	.el-cascader {
		width: 100%;
	}

	.searchTag {
		width: 130px;
	}

	.el-dialog .el-form-item {
		width: 100%;
	}

	.changeAppletClass {
		/deep/.el-form-item {
			margin-bottom: 10px;
		}
	}

	/deep/ .saveStyle {
		width: 100%;
		text-align: center;
		padding-bottom: 15px;
		border-bottom: 1px dashed #999;
	}

	.tableStyle {
		height: calc(100% - 84px);
	}

	.searchForm {
		.el-form-item {
			margin-bottom: 10px;
		}
	}

	.block {
		margin-top: 10px;
	}
</style>
